import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b053f4f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "evaluate"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-star-light" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 3,
  class: "textLink"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCustom === _ctx.constant.typeService)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.extension.title), 1),
            (_ctx.extension.hyperlinks_text)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.extension.hyperlinks_text.value,
                  target: "view_window"
                }, _toDisplayString(_ctx.extension.hyperlinks_text.key), 9, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          (_ctx.extension.item && _ctx.extension.item.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extension.item, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    (_ctx.isUrl(item.value))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: item.value,
                          target: "view_window"
                        }, _toDisplayString(item.key), 9, _hoisted_5))
                      : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.key), 1))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("article", null, _toDisplayString(_ctx.extension.description), 1)
        ]))
      : (_ctx.isCustom.businessID === _ctx.constant.typeEvaluate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('message.custom.对本次服务评价')), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(~~_ctx.isCustom.score, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "evaluate-list-item",
                  key: index
                }, _hoisted_9))
              }), 128))
            ]),
            _createElementVNode("article", null, _toDisplayString(_ctx.isCustom.comment), 1)
          ]))
        : (_ctx.isCustom.businessID === _ctx.constant.typeOrder)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "order",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.isCustom.link)))
            }, [
              _createElementVNode("img", {
                src: _ctx.isCustom.imageUrl,
                alt: ""
              }, null, 8, _hoisted_10),
              _createElementVNode("main", null, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.isCustom.title), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.isCustom.description), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.isCustom.price), 1)
              ])
            ]))
          : (_ctx.isCustom.businessID === _ctx.constant.typeTextLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", null, _toDisplayString(_ctx.isCustom.text), 1),
                _createElementVNode("a", {
                  href: _ctx.isCustom.link,
                  target: "view_window"
                }, _toDisplayString(_ctx.$t('message.custom.查看详情>>')), 9, _hoisted_12)
              ]))
            : (_ctx.isCustom.businessID === _ctx.constant.TYPE_CALL_MESSAGE)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(["call", `call-${_ctx.data?.message?.conversationType}`]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCallAgain && _ctx.handleCallAgain(...args)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon", _ctx.handleCallMessageIcon()])
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.custom), 1)
                ], 2))
              : (_openBlock(), _createElementBlock("span", {
                  key: 5,
                  innerHTML: _ctx.data.custom
                }, null, 8, _hoisted_13))
  ]))
}